export default __webpack_public_path__ + "static/media/post-01.d16c9cee.jpg";